import { calendarHolidays } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveDefaultCalendarHolidaysRequestFailure({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isRetrieveDefaultCalendarHolidaysRequestPending({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isRetrieveDefaultCalendarHolidaysRequestSuccess({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
    getDefaultCalendarHolidays({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state
        ? state.defaultCalendarHolidays
        : { ...calendarHolidays, uuid: "" };
    },
  };
}

export { createSelector };
